export default __webpack_public_path__ + "static/media/pic3.2f943cd5.png";